import { CopyIcon } from "lucide-react"
import { type ComponentProps } from "react"
import { useTranslation } from "react-i18next"

import { Button } from "@/components/ui/button"
import { useCopyToClipboard } from "@/hooks/use-copy-to-clipboard"

interface ClipboardButtonProps
  extends ComponentProps<typeof Button> {
  text: string
  message?: string
  /**
   * Nome do campo copiado ("Transação", "Cliente"). Vira o rótulo acessível do botão.
   *
   * Sem ele, uma tela com dez botões de cópia tem dez nomes idênticos e quem navega por leitor
   * de tela ou comando de voz não distingue qual copia o quê.
   */
  label?: string
}

export const ClipboardButton = ({
  text,
  message,
  label,
  ...props
}: ClipboardButtonProps) => {
  const { t } = useTranslation()
  const copyToClipboard = useCopyToClipboard()

  return (
    <Button
      variant="outline"
      size="icon"
      onClick={() => void copyToClipboard(text, message)}
      {...props}
    >
      <span className="sr-only">
        {label
          ? t("common.copyField", { field: label })
          : t("common.copy")}
      </span>
      <CopyIcon size={16} />
    </Button>
  )
}
